<template>
  <div class="app">
    <div class="title-container">
      <h1 class="title">Your Brand Name</h1>
      <h2 v-if="isEng" class="subtitle" style="font-size: 20px;">
        LIVE COMPETITIONS
      </h2>
      <h2 v-else class="subtitle">مسابقة لايف</h2>
    </div>
    <div class="main-container">
      <div
        class="loggedin-container"
        :style="isEng ? { right: 0, direction: 'rtl' } : { left: 0 }"
      >
        <button
          class="button-disabled"
          :style="
            isEng
              ? { borderRadius: '2rem 0 0 2rem' }
              : { borderRadius: '0 2rem 2rem 0' }
          "
          v-if="!checked"
        >
          <span v-if="isEng" style="font-size: 20px;">Login with Facebook</span>
          <span v-else>تسجيل الدخول باستخدام الفيسبوك</span>
        </button>
        <button
          class="button"
          @click="newFacebookLoginHandler"
          :style="
            isEng
              ? { borderRadius: '2rem 0 0 2rem' }
              : { borderRadius: '0 2rem 2rem 0' }
          "
          v-else-if="!isLoggedin"
        >
          <span v-if="isEng" style="font-size: 20px;">Login with Facebook</span>
          <span v-else>تسجيل الدخول باستخدام الفيسبوك</span>
        </button>
        <button
          class="button"
          v-else
          :style="
            isEng
              ? { borderRadius: '2rem 0 0 2rem' }
              : { borderRadius: '0 2rem 2rem 0' }
          "
        >
          <span v-if="isEng" style="font-size: 20px;">Please Wait...</span>
          <span v-else>الرجاء الانتظار...</span>
        </button>
      </div>
      <div class="terms-container">
        <div
          class="item-container"
          :style="isEng ? { direction: 'ltr' } : { direction: 'rtl' }"
        >
          <input type="checkbox" id="checkbox" v-model="checked" />
          <span v-if="isEng" style="font-size:1rem;color:#fff;"
            >I agree to</span
          >
          <span v-else style="font-size:1rem;color:#fff;">أوافق على</span>
        </div>
        <div class="links-container">
          <div class="link-container">
            <a
              href="https://shaga3app.com/en/termsandconditions.html"
              target="_blank"
              ><span v-if="isEng" class="link-text">Terms and Conditions</span>
              <span class="link-text" v-else>الأحكام والشروط</span></a
            >
          </div>
          <div><span class="other-text">&</span></div>
          <div class="link-container">
            <a href="https://shaga3app.com/en/privacy.html" target="_blank"
              ><span class="link-text" v-if="isEng">Privacy Policy</span>
              <span class="link-text" v-else>سياسة الخصوصية</span></a
            >
          </div>
        </div>
      </div>
      <div class="powerby-container">
        <span class="powerby-title">
          Powered by
          <a href="https://shaga3app.com/en/index.html" target="_blank"
            ><span class="powerby-company">SHAGA3APP</span></a
          ></span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fbLoggedIn: false,
      checked: false,
    };
  },
  methods: {
    newFacebookLoginHandler() {
      window.location.href = `https://www.facebook.com/v17.0/dialog/oauth?client_id=1958558457798463&redirect_uri=${window.location.origin}/&scope=email,public_profile`;
    },
  },
  created() {
    if (this.$route.query.code) {
      const CS = "2e4d76a10c9d822bd5a9b5e15aca90db";
      const appId = "1958558457798463";
      const code = this.$route.query.code;
      this.fbLoggedIn = true;
      this.checked = true;
      fetch(
        `https://graph.facebook.com/v17.0/oauth/access_token?client_id=${appId}&redirect_uri=${window.location.origin}/&client_secret=${CS}&code=${code}`
      )
        .then((response) => response.json())
        .then((data) => {
          const token = data.access_token;
          fetch(
            `https://graph.facebook.com/v17.0/me?fields=id,name,email,picture&access_token=${token}`
          )
            .then((response) => response.json())
            .then((da) => {
              const user = { ...da };
              const auth = {
                accessToken: data.access_token,
                expiresIn: data.expires_in,
              };
              // alert(JSON.stringify(user));
              this.$store.dispatch("fbLogin", { user, auth });
            });
        });
    }
  },
  updated() {
    if (this.$route.query.code) {
      this.fbLoggedIn = true;
      this.checked = true;
    }
    if (this.$route.query.videoId) {
      const singleVideoData = this.$route.query.videoId;
      sessionStorage.setItem("vid", singleVideoData);
      this.$store.dispatch("saveSingleVideoData", singleVideoData);
    }
    this.$store.dispatch("saveUrl");
  },
  mounted() {
    if (this.$route.query.code) {
      this.fbLoggedIn = true;
      this.checked = true;
    }
    if (this.$route.query.videoId) {
      const singleVideoData = this.$route.query.videoId;
      sessionStorage.setItem("vid", singleVideoData);
      this.$store.dispatch("saveSingleVideoData", singleVideoData);
    }
    this.$store.dispatch("saveUrl");
  },
  computed: {
    isLoggedin() {
      if (this.$store.getters.isLoggedIn) {
        return true;
      }
      return this.fbLoggedIn;
    },
    isEng() {
      if (window.navigator.language.includes("ar")) {
        return false;
      } else {
        return true;
      }
    },
    isChecked() {
      return this.isClickedTerms;
    },
  },
};
</script>

<style>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-image: url("../assets/images/main.png");
  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;
  z-index: 10;
}
/* .bg-image {
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 50%;
  object-fit: contain;
  background-image: url("../assets/images/triangles.png");
  background-repeat: no-repeat;
  background-position: top;
  background-size: contain;
} */
.title-container {
  width: 100%;
  z-index: 10;
}
.title {
  font-family: Cairo, sans-serif;
  font-size: 30px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  margin-top: 30px;
  margin-bottom: 10px;
}
.subtitle {
  font-family: Cairo, sans-serif;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  margin: 2px 0 30px 0;
}
.image-container {
  width: 55%;
  margin: 10px auto;
  z-index: 10;
}
.main-container {
  width: 100%;
  position: absolute;
  bottom: 0%;
}
.image {
  width: 100%;
  object-fit: contain;
}
.loggedin-container {
  width: 100%;
  margin-bottom: 10px;
}
.button-disabled {
  font-family: Cairo, sans-serif;
  font-weight: bold;
  color: white;
  width: 80%;
  min-width: 150px;
  background-image: linear-gradient(#191919, #191919);
  height: 3rem;
  border-radius: 2rem 0 0 2rem;
  font-size: 14px;
  padding: 10px 15px 10px 46px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
}
button {
  font-family: Cairo, sans-serif;
  font-weight: bold;
  color: white;
  width: 80%;
  min-width: 150px;
  background-image: linear-gradient(#4c69ba, #3b55a0);
  height: 3rem;
  border-radius: 2rem 0 0 2rem;
  font-size: 14px;
  padding: 10px 15px 10px 46px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
}
button img {
  /* display: none !important; */
  margin: 10px 5px;
  width: 20px !important;
  height: 20px !important;
}
button .spinner {
  display: none !important;
}

.powerby-container {
  width: 100%;
  margin-bottom: 10px;
}
.powerby-title {
  font-family: AvenirNextRegular, sans-serif;
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}
.powerby-company {
  color: #d1000d;
  font-size: 14px;
  font-weight: bold;
}
.terms-container {
  text-align: center;
  width: 100%;
  margin: 15px auto;
}
.links-container {
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.item-container {
  width: 100%;
  text-align: center;
}
.link-container {
  width: auto;
  text-align: start;
  padding: 0;
}
.link-text {
  color: #fff;
  font-size: 0.7rem;
  text-decoration: underline;
}
.other-text {
  color: #fff;
  font-size: 1rem;
  margin: 0 10px;
}
</style>
